import { render, staticRenderFns } from "./GalleryChrome.vue?vue&type=template&id=0ad7beac&"
import script from "./GalleryChrome.vue?vue&type=script&lang=js&"
export * from "./GalleryChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports